<template>
<!-- 新疆新闻地图2020.12.23 -->
  <div class="timeNews-container"> 
    <div class="title-container">  
<div class="head_title">
  <!-- <img class="head_img" src="../assets/icons.png" /> -->
  全国交通热点
     </div>
      <!-- <div class="select-box">
        <el-select v-model="provinceName" placeholder="请选择地域" @change="changeLoc()">
          <el-option v-for="item in locList" :key="item.name" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </div> -->
    </div>
    <div class="newslistbox">
      <div class="zhudao" @click="zhu()" v-if="this.vist==true"><img src="../assets/map/zhudao.png" alt=""></div>
      <div class="diaoyu" @click="diaoyu()" v-if="this.vist==true"><img src="../assets/map/diaoyu.png" alt="">
      <span>钓鱼岛</span>
      </div>
      <div class="chiwei" @click="chiwei()" v-if="this.vist==true"> <img src="../assets/map/chiwei.png" alt="">
      <span>赤尾屿</span>
      </div>
      <div class="map" id="chinaMap"></div>
  <div class="right_time">
     <div v-if="this.cityName=='全国'" class="quan">全国新闻</div>
        <ul class="newsList">
        <li
          class="mapNewsList"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div class="listboxtips">
            <div class="tip">
              <p>{{ item.date }}</p>
              <p>{{ item.source }}</p>
            </div>
          </div>
       
             <h3 @click="geList(item)" class="mainTitle">
            {{ item.title }}
          </h3>
           <p  v-if="item.content=='null'" class="subTitle">
            {{ item.content}}
          </p>
          <p v-else class="subTitle">
            {{ item.content}}
          </p>
         
        </li>
      </ul>
    </div>
    </div>
            <el-dialog
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div class="body_tiele">{{this.list.title}} <img class="body_img" @click="goDetail(list.netURL)" src="@/assets/lian.png" alt=""> </div>
    <div class="live">{{this.list.source}}<div>{{this.list.date}}</div></div>
    <div  class="body_cont">
       {{this.list.content}}
       <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in imgs" :key="index">
         <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
     
        </div>
        </div> 
    </div>
  <span slot="footer" class="dialog-footer">
    
  </span>
</el-dialog>
  </div>
</template>

<script>
import echarts from "echarts";
import { mapNew } from "@/api/map.js";
import axios from "axios";
import $ from "jquery";
export default {
  data() {
    return {
      userId: "",
      newsList: [],
      bost:true,
      vist:true,
      newsChangeInterval: "",
      newsChangeTimeout: "",
     dialogVisible: false,
      list:{},
     imgs:[],     //弹框图片
      provinceName: "全国", // 下拉菜单v-model
      cityName: "全国", // List请求参数
      locList: [
        { name: "全国", mapName: "china" },
        { name: "北京", mapName: "beijing" },
        { name: "天津", mapName: "tianjin" },
        { name: "河北", mapName: "hebei" },
        { name: "山西", mapName: "shanxi" },
        { name: "内蒙古", mapName: "neimenggu" },
        { name: "辽宁", mapName: "liaoning" },
        { name: "吉林", mapName: "jilin" },
        { name: "黑龙江", mapName: "heilongjiang" },
        { name: "上海", mapName: "shanghai" },
        { name: "江苏", mapName: "jiangsu" },
        { name: "浙江", mapName: "zhejiang" },
        { name: "安徽", mapName: "anhui" },
        { name: "福建", mapName: "fujian" },
        { name: "江西", mapName: "jiangxi" },
        { name: "山东", mapName: "shandong" },
        { name: "河南", mapName: "henan" },
        { name: "湖北", mapName: "hubei" },
        { name: "湖南", mapName: "hunan" },
        { name: "广东", mapName: "guangdong" },
        { name: "广西", mapName: "guangxi" },
        { name: "海南", mapName: "hainan" },
        { name: "重庆", mapName: "chongqing" },
        { name: "四川", mapName: "sichuan" },
        { name: "贵州", mapName: "guizhou" },
        { name: "云南", mapName: "yunnan" },
        { name: "西藏", mapName: "xizang" },
        { name: "陕西", mapName: "shanxi" },
        { name: "甘肃", mapName: "gansu" },
        { name: "青海", mapName: "qinghai" },
        { name: "宁夏", mapName: "ningxia" },
        { name: "新疆", mapName: "xinjiang" },
        // { name: "台湾", mapName: "taiwan" }, // 暂无文件
        { name: "香港", mapName: "xianggang" },
        { name: "澳门", mapName: "aomen" },
      ],
      nowMapData: [], // 当前地图显示的市、县、区 名称数组
      logo_src: '',
      bg_src: '',
    };
  },
  mounted() {
        this.getMap();  //绘制地图
        this.getNewsList() //接口调试  
        this.coom();   //显示钓鱼岛 诸岛屿
      for(let i = 0;i<5;i++){
      this.newsList.push({date:'',kFrom:'',url:'',title:'',describ:''})
    } 
  },
  destroyed() {
    clearInterval(this.newsChangeInterval);
    clearTimeout(this.newsChangeTimeout)
  },
  methods: {
    zhu(){  
  this.cityName='海南' 
   this.getNewsList()
    },
      diaoyu(){  
  this.cityName='台湾' 
   this.getNewsList()
    },
      chiwei(){  
  this.cityName='台湾' 
   this.getNewsList()
    },
   coom(){
  if(this.cityName=='全国'){
   this.vist=true;
 }else{
   this.vist=false;
 }
      },
      //点击弹框
 geList(item){
      this.dialogVisible=true
      this.list=item
     var data1=item.imgs
    // 图片处理
 var demArray1 =[];
 var demArray1 = data1.map(item => {
     return {
        imgUrl: item
        }
      })
  this.imgs=demArray1
    },
        //关闭弹框
    handleClose(done) {
      this.imgs=[];
       this.dialogVisible=false
      },
          // 打开新页面
    goDetail(url) {
          window.open(url);
    },
      // 下拉框 选择区域
    changeLoc() {
      this.bost=true;
      this.cityName = this.provinceName;
      clearInterval(this.newsChangeInterval)
      clearTimeout(this.newsChangeTimeout)
      this.newsChangeInterval = ''
      this.coom();
      this.getMap();
      this.getNewsList();
    },
    goDetail(c) {
      window.open(c);
    },
  
    // 右侧新闻数据更新
    getNewsList() {
//     if(this.cityName=='全国'||this.cityName=='北京'||this.cityName=='上海'||this.cityName=='天津'||this.cityName=='重庆'||this.cityName=='黑龙江'||
//    this.cityName=='辽宁'||this.cityName=='吉林'||this.cityName=='河北'||this.cityName=='河南'||this.cityName=='湖北'||this.cityName=='湖南'||
//   this.cityName=='山东'||this.cityName=='山西'||this.cityName=='陕西'||this.cityName=='安徽'||this.cityName=='浙江'||
//   this.cityName=='江苏'||this.cityName=='福建'||this.cityName=='广东'||this.cityName=='海南'||this.cityName=='四川'||
//   this.cityName=='云南'||this.cityName=='贵州'||this.cityName=='青海'||this.cityName=='甘肃'||this.cityName=='台湾'||
//   this.cityName=='内蒙古'||this.cityName=='宁夏'||this.cityName=='新疆'||this.cityName=='西藏'||this.cityName=='广西'||
//  this.cityName=='香港'||this.cityName=='澳门'){
//      mapNew({
//       proName:this.cityName
//       }).then(res=>{
//           this.newsList = res.data.data.slice(0,6); 
//       })
//         }else if(this.bost==false){
//         mapNew({
//      countyName:this.cityName
//       }).then(res=>{
//           this.newsList = res.data.data.slice(0,6); 
//       })    
//      }else{
//         mapNew({
//      cityName:this.cityName
//       }).then(res=>{
//           this.newsList = res.data.data.slice(0,6); 
//       })  
//      }
     mapNew({
      proName:this.cityName,
     text:'交通'
      }).then(res=>{
          this.newsList = res.data.data.slice(0,6); 
      }) 

    },
    getMap() {
      var vm = this;
      if(vm.chart && vm.chart.dispose && vm.chart.dispose()){
        vm.chart.dispose()
      }
      //地图容器
      vm.chart = echarts.init(document.getElementById("chinaMap"));
      //34个省、市、自治区的名字拼音映射数组
      var provinces = {
        北京: "beijing",
        天津: "tianjin",
        河北: "hebei",
        山西: "shanxi",
        内蒙古: "neimenggu",
        辽宁: "liaoning",
        吉林: "jilin",
        黑龙江: "heilongjiang",
        上海: "shanghai",
        江苏: "jiangsu",
        浙江: "zhejiang",
        安徽: "anhui",
        福建: "fujian",
        江西: "jiangxi",
        山东: "shandong",
        河南: "henan",
        湖北: "hubei",
        湖南: "hunan",
        广东: "guangdong",
        广西: "guangxi",
        海南: "hainan",
        重庆: "chongqing",
        四川: "sichuan",
        贵州: "guizhou",
        云南: "yunnan",
        西藏: "xizang",
        陕西: "shanxi1",
        甘肃: "gansu",
        青海: "qinghai",
        宁夏: "ningxia",
        新疆: "xinjiang",
        // 台湾: "taiwan",
        香港: "xianggang",
        澳门: "aomen"
      };

      var d = [];
      var cur = 0;
      var cityMap = {
        北京市: "110100",
        天津市: "120100",
        上海市: "310100",
        重庆市: "500100",
        崇明县: "310200",
        湖北省直辖县市: "429000",
        铜仁市: "522200",
        毕节市: "522400",
        石家庄市: "130100",
        唐山市: "130200",
        秦皇岛市: "130300",
        邯郸市: "130400",
        邢台市: "130500",
        保定市: "130600",
        张家口市: "130700",
        承德市: "130800",
        沧州市: "130900",
        廊坊市: "131000",
        衡水市: "131100",
        太原市: "140100",
        大同市: "140200",
        阳泉市: "140300",
        长治市: "140400",
        晋城市: "140500",
        朔州市: "140600",
        晋中市: "140700",
        运城市: "140800",
        忻州市: "140900",
        临汾市: "141000",
        吕梁市: "141100",
        呼和浩特市: "150100",
        包头市: "150200",
        乌海市: "150300",
        赤峰市: "150400",
        通辽市: "150500",
        鄂尔多斯市: "150600",
        呼伦贝尔市: "150700",
        巴彦淖尔市: "150800",
        乌兰察布市: "150900",
        兴安盟: "152200",
        锡林郭勒盟: "152500",
        阿拉善盟: "152900",
        沈阳市: "210100",
        大连市: "210200",
        鞍山市: "210300",
        抚顺市: "210400",
        本溪市: "210500",
        丹东市: "210600",
        锦州市: "210700",
        营口市: "210800",
        阜新市: "210900",
        辽阳市: "211000",
        盘锦市: "211100",
        铁岭市: "211200",
        朝阳市: "211300",
        葫芦岛市: "211400",
        长春市: "220100",
        吉林市: "220200",
        四平市: "220300",
        辽源市: "220400",
        通化市: "220500",
        白山市: "220600",
        松原市: "220700",
        白城市: "220800",
        延边朝鲜族自治州: "222400",
        哈尔滨市: "230100",
        齐齐哈尔市: "230200",
        鸡西市: "230300",
        鹤岗市: "230400",
        双鸭山市: "230500",
        大庆市: "230600",
        伊春市: "230700",
        佳木斯市: "230800",
        七台河市: "230900",
        牡丹江市: "231000",
        黑河市: "231100",
        绥化市: "231200",
        大兴安岭地区: "232700",
        南京市: "320100",
        无锡市: "320200",
        徐州市: "320300",
        常州市: "320400",
        苏州市: "320500",
        南通市: "320600",
        连云港市: "320700",
        淮安市: "320800",
        盐城市: "320900",
        扬州市: "321000",
        镇江市: "321100",
        泰州市: "321200",
        宿迁市: "321300",
        杭州市: "330100",
        宁波市: "330200",
        温州市: "330300",
        嘉兴市: "330400",
        湖州市: "330500",
        绍兴市: "330600",
        金华市: "330700",
        衢州市: "330800",
        舟山市: "330900",
        台州市: "331000",
        丽水市: "331100",
        合肥市: "340100",
        芜湖市: "340200",
        蚌埠市: "340300",
        淮南市: "340400",
        马鞍山市: "340500",
        淮北市: "340600",
        铜陵市: "340700",
        安庆市: "340800",
        黄山市: "341000",
        滁州市: "341100",
        阜阳市: "341200",
        宿州市: "341300",
        六安市: "341500",
        亳州市: "341600",
        池州市: "341700",
        宣城市: "341800",
        福州市: "350100",
        厦门市: "350200",
        莆田市: "350300",
        三明市: "350400",
        泉州市: "350500",
        漳州市: "350600",
        南平市: "350700",
        龙岩市: "350800",
        宁德市: "350900",
        南昌市: "360100",
        景德镇市: "360200",
        萍乡市: "360300",
        九江市: "360400",
        新余市: "360500",
        鹰潭市: "360600",
        赣州市: "360700",
        吉安市: "360800",
        宜春市: "360900",
        抚州市: "361000",
        上饶市: "361100",
        济南市: "370100",
        青岛市: "370200",
        淄博市: "370300",
        枣庄市: "370400",
        东营市: "370500",
        烟台市: "370600",
        潍坊市: "370700",
        济宁市: "370800",
        泰安市: "370900",
        威海市: "371000",
        日照市: "371100",
        莱芜市: "371200",
        临沂市: "371300",
        德州市: "371400",
        聊城市: "371500",
        滨州市: "371600",
        菏泽市: "371700",
        郑州市: "410100",
        开封市: "410200",
        洛阳市: "410300",
        平顶山市: "410400",
        安阳市: "410500",
        鹤壁市: "410600",
        新乡市: "410700",
        焦作市: "410800",
        濮阳市: "410900",
        许昌市: "411000",
        漯河市: "411100",
        三门峡市: "411200",
        南阳市: "411300",
        商丘市: "411400",
        信阳市: "411500",
        周口市: "411600",
        驻马店市: "411700",
        省直辖县级行政区划: "469000",
        武汉市: "420100",
        黄石市: "420200",
        十堰市: "420300",
        宜昌市: "420500",
        襄阳市: "420600",
        鄂州市: "420700",
        荆门市: "420800",
        孝感市: "420900",
        荆州市: "421000",
        黄冈市: "421100",
        咸宁市: "421200",
        随州市: "421300",
        恩施土家族苗族自治州: "422800",
        长沙市: "430100",
        株洲市: "430200",
        湘潭市: "430300",
        衡阳市: "430400",
        邵阳市: "430500",
        岳阳市: "430600",
        常德市: "430700",
        张家界市: "430800",
        益阳市: "430900",
        郴州市: "431000",
        永州市: "431100",
        怀化市: "431200",
        娄底市: "431300",
        湘西土家族苗族自治州: "433100",
        广州市: "440100",
        韶关市: "440200",
        深圳市: "440300",
        珠海市: "440400",
        汕头市: "440500",
        佛山市: "440600",
        江门市: "440700",
        湛江市: "440800",
        茂名市: "440900",
        肇庆市: "441200",
        惠州市: "441300",
        梅州市: "441400",
        汕尾市: "441500",
        河源市: "441600",
        阳江市: "441700",
        清远市: "441800",
        东莞市: "441900",
        中山市: "442000",
        潮州市: "445100",
        揭阳市: "445200",
        云浮市: "445300",
        南宁市: "450100",
        柳州市: "450200",
        桂林市: "450300",
        梧州市: "450400",
        北海市: "450500",
        防城港市: "450600",
        钦州市: "450700",
        贵港市: "450800",
        玉林市: "450900",
        百色市: "451000",
        贺州市: "451100",
        河池市: "451200",
        来宾市: "451300",
        崇左市: "451400",
        海口市: "460100",
        三亚市: "460200",
        三沙市: "460300",
        成都市: "510100",
        自贡市: "510300",
        攀枝花市: "510400",
        泸州市: "510500",
        德阳市: "510600",
        绵阳市: "510700",
        广元市: "510800",
        遂宁市: "510900",
        内江市: "511000",
        乐山市: "511100",
        南充市: "511300",
        眉山市: "511400",
        宜宾市: "511500",
        广安市: "511600",
        达州市: "511700",
        雅安市: "511800",
        巴中市: "511900",
        资阳市: "512000",
        阿坝藏族羌族自治州: "513200",
        甘孜藏族自治州: "513300",
        凉山彝族自治州: "513400",
        贵阳市: "520100",
        六盘水市: "520200",
        遵义市: "520300",
        安顺市: "520400",
        黔西南布依族苗族自治州: "522300",
        黔东南苗族侗族自治州: "522600",
        黔南布依族苗族自治州: "522700",
        昆明市: "530100",
        曲靖市: "530300",
        玉溪市: "530400",
        保山市: "530500",
        昭通市: "530600",
        丽江市: "530700",
        普洱市: "530800",
        临沧市: "530900",
        楚雄彝族自治州: "532300",
        红河哈尼族彝族自治州: "532500",
        文山壮族苗族自治州: "532600",
        西双版纳傣族自治州: "532800",
        大理白族自治州: "532900",
        德宏傣族景颇族自治州: "533100",
        怒江傈僳族自治州: "533300",
        迪庆藏族自治州: "533400",
        拉萨市: "540100",
        昌都地区: "542100",
        山南地区: "542200",
        日喀则地区: "542300",
        那曲地区: "542400",
        阿里地区: "542500",
        林芝地区: "542600",
        西安市: "610100",
        铜川市: "610200",
        宝鸡市: "610300",
        咸阳市: "610400",
        渭南市: "610500",
        延安市: "610600",
        汉中市: "610700",
        榆林市: "610800",
        安康市: "610900",
        商洛市: "611000",
        兰州市: "620100",
        嘉峪关市: "620200",
        金昌市: "620300",
        白银市: "620400",
        天水市: "620500",
        武威市: "620600",
        张掖市: "620700",
        平凉市: "620800",
        酒泉市: "620900",
        庆阳市: "621000",
        定西市: "621100",
        陇南市: "621200",
        临夏回族自治州: "622900",
        甘南藏族自治州: "623000",
        西宁市: "630100",
        海东地区: "632100",
        海北藏族自治州: "632200",
        黄南藏族自治州: "632300",
        海南藏族自治州: "632500",
        果洛藏族自治州: "632600",
        玉树藏族自治州: "632700",
        海西蒙古族藏族自治州: "632800",
        银川市: "640100",
        石嘴山市: "640200",
        吴忠市: "640300",
        固原市: "640400",
        中卫市: "640500",
        乌鲁木齐市: "650100",
        克拉玛依市: "650200",
        吐鲁番地区: "652100",
        哈密地区: "652200",
        昌吉回族自治州: "652300",
        博尔塔拉蒙古自治州: "652700",
        巴音郭楞蒙古自治州: "652800",
        阿克苏地区: "652900",
        克孜勒苏柯尔克孜自治州: "653000",
        喀什地区: "653100",
        和田地区: "653200",
        伊犁哈萨克自治州: "654000",
        塔城地区: "654200",
        阿勒泰地区: "654300",
        自治区直辖县级行政区划: "659000",
        // 台湾省: "710000",
        香港特别行政区: "810100",
        澳门特别行政区: "820000"
      };

      if(vm.provinceName === '全国'){ // 绘制全国地图'
         axios.get("/map/china.json").then(res=>{
          var _data = res.data;
          _data.features = _data.features.sort((a,b) => Number(a.id) - Number(b.id));
          var d = [];
          for (var i = 0; i < _data.features.length; i++) {
            d.push({ name: _data.features[i].properties.name, value: Math.round(Math.random() * 1000) });
          }
          vm.nowMapData = d;
          //注册地图
          echarts.registerMap(vm.provinceName, _data);
          renderMap(vm.provinceName, d);
        });
      } else { // 绘制各省地图
        axios.get("/map/province/" +provinces[vm.provinceName] +".json").then(res=>{
          var d = [];
          for (var i = 0; i < res.data.features.length; i++) {
            d.push({ name: res.data.features[i].properties.name, value: Math.round(Math.random() * 1000) });
          }
          vm.nowMapData = d;
          //注册地图
          echarts.registerMap(vm.provinceName, res.data);
          renderMap(vm.provinceName, d);
        })
      }
      
      //初始化地图配置
      var option = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(20,80,170,.4)",
          borderColor: "#50cdf6",
          borderWidth: 1,
          padding: [1, 4],
          formatter: function(param) {
            return param ? param.data.name : "";
          }
        },
       
        visualMap: {
        show:false,
          min: 0,
          max: 1000,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          calculable: true,
          color: ["#0B1739","#152B6B","#1A2F75","#213E96","#1D46AD"],
          textStyle: {
            color: "#fff",
            fontSize: 12
          }
        },
        roamController: {
          show: true,
          x: "right",
          mapTypeControl: {
            china: true
          }
        },
        animationDuration: 1000,
        animationEasing: "cubicOut",
        animationDurationUpdate: 1000
      };

      function renderMap(map, data) {
        option.series = [{
          type: "map",
          mapType: map,
          roam: false,
        zoom: 0.88,
          nameMap: {
            china: "中国"
          },
          label: {
            normal: {
              show: true,
              color:'#a8e6e1',
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#fff",//地名
                fontSize: 12
              }
            }
          },
       
          itemStyle: {
            normal: {
              borderColor: "#50cdf6",//地图边界线
              borderWidth: 1
            },
            emphasis: {
              areaColor: "#00ccff"//鼠标hover
            }
          },
          data: data
        }];

        vm.chart.setOption(option) //渲染地图
        window.addEventListener("resize", () => { vm.chart.resize() });

        var _city; // 当前高亮城市
        // function inter() {
        //   /**
        //    * interval.delay = 12000ms
        //    * 以cur为计数器，确定当前高亮城市
        //    * 执行高亮，请求数据，setTimeout.delay = 10000ms 清除高亮 ，cur++
        //    * cur === nowMapData.length - 1 -> cur =0
        //    */
        //   return setInterval(function() { // cur=0
        //       var dataLen = vm.nowMapData.length;
        //       _city = vm.nowMapData[cur];
        //       vm.cityName = _city.name;
        //       vm.chart.dispatchAction({ type: "highlight", name: _city.name });
        //       vm.getNewsList();
        //     console.log( vm.cityName,_city,'地区所在');
            
        //       wait(_city)
        //       cur == dataLen - 1 ? cur = 0 : cur++;
        //   }, 2000);
        // }
        // function wait(city) { // 清除高亮
        //   var _name = String(city.name)
        //   vm.newsChangeTimeout = setTimeout(function() {
        //     vm.chart.dispatchAction({ type: "downplay", name: _name }); // 清除高亮
        //   }, 2000)
        // }
        vm.newsChangeInterval = inter();
      }

      //地图点击事件
      vm.chart.on("click", function(params) { //event.event.style.fill
      console.log(params.name)
      vm.cityName = params.name; 
      vm.getNewsList()
        params.color = "darkorange";
        // if (params.name in provinces) { // 点击的是34个省、市、自治区，绘制选中地区的二级地图
        //   vm.provinceName = params.name;
        //   vm.cityName = params.name;
        //   vm.coom();
        //   console.log(vm.cityName,'city');
        //    vm.bost=true;
        //   cur = vm.nowMapData.indexOf(params.name) + 1;
        //   clearInterval(vm.newsChangeInterval)
        //   clearTimeout(vm.newsChangeTimeout)
        //   axios.get("/map/province/" + provinces[params.name] +".json").then(res=>{
        //     var d = [];
        //     for (var i = 0; i < res.data.features.length; i++) {
        //       d.push({ name: res.data.features[i].properties.name, value: Math.round(Math.random() * 1000) });
        //     }
        //     vm.nowMapData = d;
        //     //注册地图
        //     echarts.registerMap(vm.provinceName, res.data);
        //     renderMap(vm.provinceName, d);
        //   })
        //     vm.getNewsList();
        // } else if (params.name in cityMap) { // 点击的是34个省、市、自治区，绘制选中地区的二级地图
        //   vm.cityName = params.name;
        //   console.log(vm.cityName,'我要耳机')
        //   vm.bost=false;
        //   cur = vm.nowMapData.indexOf(params.name) + 1;
        //   clearInterval(vm.newsChangeInterval)
        //   clearTimeout(vm.newsChangeTimeout)
        //   $.getJSON("/map/city/" + cityMap[params.name] + ".json",function(data) {
        //     var d = [];
        //     for (var i = 0; i < data.features.length; i++) {
        //       d.push({ name: data.features[i].properties.name, value: Math.round(Math.random() * 1000) });
        //     }
        //     vm.nowMapData = d;
        //     //注册地图
        //     echarts.registerMap(params.name, data);
        //     renderMap(params.name, d);
        //   });
        // } else {
        //  vm.bost=true;
        //   vm.cityName = params.name;
        //   vm.getNewsList();
        // }
      });
    }
  }
};
</script>
<style >
.el-input__inner{
  background-color: rgba(3, 19, 43, 1) !important;
  color: rgba(29, 182, 233, 1) !important;
  border: 1px solid  rgba(29, 182, 233, 1) !important;
}
</style>
<style lang="scss">
//弹框样式
.quan{
  position: absolute;
 top:1vh;
right: 28px;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
  color: #fff;
  font-size: 24px;
  width: 28.39vw;
  height: 20px;
}
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
// justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
.img_wx{
  width:170px;
  height: 140px;
}
}
.body_tiele{
  font-size: 30px;
font-family: PingFang;
font-weight: bold;
color: #FFFFFF;
line-height: 36px;
text-align: center;
}
.body_img{
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live{
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #60D6DD;
}
.body_cont{
  width: 90%;
  height: 60vh;
 overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 28px;
color: #FFFFFF;
}
.timeNews-container {
  width: 100%;
  height: 100%;
  background-image: url("../assets/Starting/img-information/expert_bg_img.jpg");
  background-size: 100% 100%;
  .title-container {
    height: 5vh;
.head_title{
font-size: 2rem;
font-family: Microsoft YaHei;
font-weight: bold;
color: #FFFFFF;
line-height: 10vh;
color: #FFFFFF;
position: relative;
width: 400px;
height: 10vh;
display: flex;
justify-content: space-around;
.head_img{
   position: relative;
   left: 30px;
  top: 29px;
  width:48px;
  height: 48px;
}
}

    .title {
      color: #fff;
      font-size: 4.63vh;
      font-weight: 700;
      padding-left: 17.5vh;
      padding-top: 3.3vh;
    }
    .select-box {
      width: 220px;
      position: absolute;
      left:35%;
      top: 4%;
      z-index: 99;
      .el-select {
        .el-input {
          .el-input__inner {
          }
        }
      }
    }
  }
  .newslistbox {
    width: 100vw;
    height: 90vh;
    font-size: 3vh;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    position: relative;
.zhudao{
   
    position: absolute;
    bottom: 8vh;
    left: 46vw;
    cursor: pointer;
    z-index: 111;


}
.diaoyu{
position: absolute;
    bottom: 25vh;
    left: 44.5vw;
    cursor: pointer;
    z-index: 111;
     img{
     width: 50px;
     height: 30px;
   }
   span{
    color:#a8e6e1;
     font-size: 12px;
     position: relative;
     left: -15px;
     top: -5px;
   }
}
.chiwei{
  position: absolute;
    bottom: 25.5vh;
    left: 46vw;
    cursor: pointer;
    z-index: 111;
      img{
     width: 40px;
     height: 30px;
   }
   span{
    color:#a8e6e1;
     font-size: 12px;
     position: relative;
     left: -5px;
     top: -15px;
   }
}
    .map {
        width: 61.94vw;
    height: 89.48vh;
    margin-left: 2.5vw;
    padding-top: 7vh;
    }

    .showlist {
      .mapNewsList:nth-child(n) {
        transform: translate(0, 0);
        -webkit-transform: translate(0, 0);
      }
    }
  }
}
  .newsList {
    position: absolute;
    height: 80vh;
    right: 42px;
    top: 8vh;
    width: 28.39vw;
    // padding-top: 6vh;
 
    .mapNewsList {
      position: relative;
      color: #fff;
      margin-bottom: 0.6vh;
      padding: 0.54vw;
      height:13vh;
      .listboxtips {
        width: 10vw;
        font-size: 0.73vw;
        text-align: right;
        position: absolute;
        left: calc(-11vw - 1vh);
        padding-right: 2vw;
        line-height: 2;
        height: 100%;
        white-space: nowrap;
        .tip {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
      .listboxtips:after {
        content: "";
        position: absolute;
        width: 1vh;
        height: 1vh;
        border-radius: 50%;
        top: 50%;
        margin-left: 0.5vw;
        margin-right: 0.5vw;
        background: #9fb4d6;
      }
      .mainTitle {
        font-size: 1.1rem;
        line-height: 1.4;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
      .subTitle {
        font-size: 0.8rem;
        margin-top: 1.8vh;
        line-height: 1.4;
        color: #ddd;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .mapNewsList:nth-of-type(1) {
      transition-delay: 0.2s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(2) {
      transition-delay: 0.2s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(3) {
      transition-delay: 0.4s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(4) {
      transition-delay: 0.6s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(5) {
      transition-delay: 0.8s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(6) {
      transition-delay: 1s;
      background: rgba(53, 120, 221, 0.3);
    }
    .mapNewsList:nth-of-type(7) {
      transition-delay: 1.2s;
      background: rgba(53, 120, 221, 0.3);
    }
  }
</style>
